import React from "react";
import BabylonLogo from "../../assets/babylon1.png";
import { Facebook, Linkedin, Mail, MapPinned, Phone } from "lucide-react";

const Company = [
  "About Us",
  "Contact Us",
  "Terms and Conditions",
  "Privacy Policy",
];

const OtherSerivces = ["Babylon2k Registration"];

const Footer = () => {
  return (
    <div className="flex justify-between px-24 pt-12 pb-32 bg-customGreen-700">
      <div className="flex flex-col gap-4 w-[30%]">
        <img
          className="invert"
          src={BabylonLogo}
          alt="babylon"
          height={20}
          width={200}
        />
        <h3 className="font-bold text-customText-100">
          Institute of Leadership, Entrepreneurship and Development, Inc.
          (i-LEaD)xxx
        </h3>
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="font-bold text-customText-100">Company</h3>
        <div className="space-y-1 text-sm text-customText-100">
          {Company.map((items) => (
            <li className="hover:underline hover:font-bold">{items}</li>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="font-bold text-customText-100">Other Services</h3>
        <div className="space-y-1 text-sm text-customText-100">
          {OtherSerivces.map((items) => (
            <li className="hover:underline hover:font-bold">{items}</li>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-5 w-[30%]">
        <div className="flex items-center gap-3 text-sm font-semibold text-customText-100">
          <MapPinned className="min-w-6" />
          <span>
            Cityland Pasong Tamo Tower, 2210 Chino Roces Ave., Makati City 1231
            Philippines
          </span>
        </div>
        <div className="flex items-center gap-3 text-sm font-semibold text-customText-100">
          <Mail className="min-w-6" />
          <span>ask@babylon2k.org</span>
        </div>
        <div className="flex items-center gap-3 text-sm font-semibold text-customText-100">
          <Phone className="min-w-6" />
          <span>+63-927-945-3382</span>
        </div>
        <div className="flex items-center gap-3 text-sm font-semibold text-customText-100">
          <Facebook className="min-w-6" />
          <span>facebook</span>
        </div>
        <div className="flex items-center gap-3 text-sm font-semibold text-customText-100">
          <Linkedin className="min-w-6" />
          <span>linkedin</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
